import api from "./api";

// otp Service
export const sendOtpApi = (mobile) => api.post("/send-otp", { mobile });
export const verifyOtpApi = (mobile, otp) =>
  api.post("/auth/verify-otp", { mobile, otp });
export const resendOtpApi = (mobile) =>
  api.post("/auth/resend-otp", { mobile });
export const updateProfileApi = (payload) => api.put("/user/profile", payload);

// Queries
export const fetchUsers = async () => {
  const res = await api.get("/users");
  return res.data;
};

export const fetchUserById = async (id) => {
  const res = await api.get(`/users/${id}`);
  return res.data;
};

// Mutations
export const createUser = async (data) => {
  const res = await api.post("/users", data);
  return res.data;
};

export const updateUser = async ({ id, data }) => {
  const res = await api.put(`/users/${id}`, data);
  return res.data;
};

export const deleteUser = async (id) => {
  const res = await api.delete(`/users/${id}`);
  return res.data;
};

// Contact Us Mutation
export const contactUsApi = async (data) => {
  const res = await api.post("/contact/contactUs", data);
  return res.data;
};

export const happygetcustomer = async () => {
  const res = await api.get("happy/getcustomer");
  return res.data;
};

export const HistoryApi = async (systemId) => {
  const res = await api.get(`/bookservice/history/${systemId}`);
  return res.data;
};

export const cancelBooking = async (data) => {
  const res = await api.patch(`/bookservice/servicecancel`, data);
  return res.data;
};

//  const { data, isLoading, error } = useQuery({
//     queryKey: ["user", userId],
//     queryFn: () => getUser(userId),
//     enabled: !!userId, // prevents calling if userId is undefined
//   });
